/**
 *  Load modules
 */

import './modules/burgerMenu';
import './modules/openClose';
import './modules/stickyHeader';
// import './modules/simpleParallax';
import './modules/sortList';
import './modules/carousel';
import './modules/customSelect';
import './modules/counterUp';
import './modules/menu';
import './modules/fadeReveal';
import './modules/video';
import jobBoard from './modules/jobBoard';
import './modules/teamArchive';
import './modules/hiringCenterArchive';
import './modules/archivePayEquityLaws';
import './modules/humanCapitalLinks';

import '../scss/app.scss';

$(document).ready(() => {
  function wrapBtnNav() {
    if (jQuery(window).width() >= 1024) {
      const btn = jQuery('.navbar .navbar__btn');
      const lastItem = jQuery('.navbar__nav > li').last();
      btn.appendTo(lastItem);
    }
  }

  wrapBtnNav();

  if (jQuery('.job-board__table').length) {
    const openerText = jQuery('.job-board__table-mobile-opener strong');
    const firstButton = jQuery('.job-board__table-td button').eq(0).text();

    openerText.text(firstButton);

    jQuery('.job-board__table-td button').each(function () {
      const button = jQuery(this);

      button.on('click', () => {
        openerText.text(button.text());
      });
    });
  }
  jQuery('.filter-state select').on('change', function () {
    window.location.href = jQuery(this).val();
  });

  jQuery('.articles-filter__form-col select').on('change', function (e) {
    e.preventDefault();
    let text = 'ALL ARTICLES';
    const val = jQuery(this).val();
    if (val != 'default') {
      text = `Articles Filtered by: ${jQuery(this).find('option:selected').text()}`;
    }
    const id = jQuery(this).attr('id');
    const data = {
      action: 'articles_filter',
      term_ID: val,
    };
    jQuery('.cards .container>h3').text(text);
    jQuery.ajax({
      url: myajax.url,
      type: 'POST',
      data,
      dataType: 'json',
      success(result) {
        if (result) {
          jQuery('.cards__row').html(result.posts);
          jQuery('a.btn.btn_load_more').attr('data-count_posts', result.count);
          if (result.count < 7) {
            jQuery('a.btn.btn_load_more').hide();
          } else {
            jQuery('a.btn.btn_load_more').show();
          }
          jQuery('.articles-filter__form-col select').each(function (i) {
            if (jQuery(this).attr('id') != id) {
              jQuery(this).prop('selectedIndex', 0);
              jQuery(this).parent().find('.custom-select-opener span').text(jQuery(this).find('option:first').text());
              jQuery(this).parent().find('.custom-select-panel div').each(function (i) {
                jQuery(this).removeClass('is-selected has-focus');
              });
            }
          });
          jQuery('.articles-filter__form-col .not_filter ').removeClass('active');
          jQuery('.articles-filter__form-head [role="search"] [type="search"]').val('');
        }
      },
    });
  });
  jQuery('.articles-filter__form-head [role="search"]').on('submit', function (e) {
    e.preventDefault();
    const search = jQuery(this).find('[name="s"]').val();
    const text = `Search: ${search}`;

    const id = jQuery(this).attr('id');
    const data = {
      action: 'search',
      search,
    };
    jQuery('.cards .container>h3').text(text);
    jQuery.ajax({
      url: myajax.url,
      type: 'POST',
      data,
      dataType: 'json',
      success(result) {
        if (result) {
          jQuery('.cards__row').html(result.posts);
          jQuery('a.btn.btn_load_more').attr('data-count_posts', result.count);
          if (result.count < 7) {
            jQuery('a.btn.btn_load_more').hide();
          } else {
            jQuery('a.btn.btn_load_more').show();
          }
          jQuery('.articles-filter__form-col select').each(function (i) {
            jQuery(this).prop('selectedIndex', 0);
            jQuery(this).parent().find('.custom-select-opener span').text(jQuery(this).find('option:first').text());
            jQuery(this).parent().find('.custom-select-panel div').each(function (i) {
              if (i == 0) {
                jQuery(this).addClass('is-selected has-focus');
              } else {
                jQuery(this).removeClass('is-selected has-focus');
              }
            });
          });
          jQuery('.articles-filter__form-col .not_filter ').removeClass('active');
        }
      },
    });
  });
  jQuery('.articles-filter__form-col .not_filter ').on('click', function (e) {
    e.preventDefault();
    jQuery(this).addClass('active');
    const id = jQuery(this).attr('id');
    const text = `Articles Filtered by: ${jQuery(this).text()}`;
    const data = {
      action: 'articles_filter',
      term_ID: jQuery(this).attr('data-term_ID'),
    };
    jQuery('.cards .container>h3').text(text);
    jQuery.ajax({
      url: myajax.url,
      type: 'POST',
      data,
      dataType: 'json',
      success(result) {
        if (result) {
          jQuery('.cards__row').html(result.posts);
          jQuery('a.btn.btn_load_more').attr('data-count_posts', result.count);
          if (result.count < 7) {
            jQuery('a.btn.btn_load_more').hide();
          } else {
            jQuery('a.btn.btn_load_more').show();
          }
          jQuery('.articles-filter__form-col select').each(function (i) {
            jQuery(this).prop('selectedIndex', 0);
            jQuery(this).parent().find('.custom-select-opener span').text(jQuery(this).find('option:first').text());
            jQuery(this).parent().find('.custom-select-panel div').each(function (i) {
              if (i == 0) {
                jQuery(this).addClass('is-selected has-focus');
              } else {
                jQuery(this).removeClass('is-selected has-focus');
              }
            });
          });
          jQuery('.articles-filter__form-head [role="search"] [type="search"]').val('');
        }
      },
    });
  });
  jQuery('.articles-filter__form-row .reset__filter ').on('click', (e) => {
    e.preventDefault();
    const data = {
      action: 'articles_filter',
      term_ID: 'reset_filter',
    };
    jQuery('.cards .container>h3').text('ALL ARTICLES');
    jQuery.ajax({
      url: myajax.url,
      type: 'POST',
      data,
      dataType: 'json',
      success(result) {
        if (result) {
          jQuery('.cards__row').html(result.posts);
          jQuery('a.btn.btn_load_more').attr('data-count_posts', result.count);
          if (result.count < 7) {
            jQuery('a.btn.btn_load_more').hide();
          } else {
            jQuery('a.btn.btn_load_more').show();
          }
          jQuery('.articles-filter__form-col select').each(function (i) {
            jQuery(this).prop('selectedIndex', 0);
            jQuery(this).parent().find('.custom-select-opener span').text(jQuery(this).find('option:first').text());
            jQuery(this).parent().find('.custom-select-panel div').each(function (i) {
              if (i == 0) {
                jQuery(this).addClass('is-selected has-focus');
              } else {
                jQuery(this).removeClass('is-selected has-focus');
              }
            });
          });
          jQuery('.articles-filter__form-col .not_filter ').removeClass('active');
          jQuery('.articles-filter__form-head [role="search"] [type="search"]').val('');
        }
      },
    });
  });
  jQuery('.articles-filter a.btn.btn_load_more').on('click', (e) => {
    e.preventDefault();
    const search = jQuery('.articles-filter__form-head [role="search"]').val();
    let term_ID = 'all';
    const ids = [];
    if (jQuery('.articles-filter__form-col .not_filter ').hasClass('active')) {
      term_ID = jQuery('.articles-filter__form-col .not_filter ').attr('data-term_id');
    }
    jQuery('.articles-filter__form-col select').each(function (i) {
      if (jQuery(this).val() !== 'default') {
        term_ID = jQuery(this).val();
      }
    });
    jQuery('.cards__col').each(function () {
      ids.push(jQuery(this).attr('data-id'));
    });
    const data = {
      action: 'load_more',
      term_ID,
      ids,
      search,
    };
    // console.log(data);
    jQuery.ajax({
      url: myajax.url,
      type: 'POST',
      data,
      dataType: 'json',
      success(result) {
        if (result) {
          jQuery('.cards__row').append(result.posts);
          jQuery('a.btn.btn_load_more').attr('data-count_posts', result.count);
          if (result.count < 7) {
            jQuery('a.btn.btn_load_more').hide();
          } else {
            jQuery('a.btn.btn_load_more').show();
          }
        }
      },
    });
  });

  jQuery('#region-map path').on('mouseover', function () {
    const tabId = jQuery(this).attr('data-id');

    jQuery('#region-map path').removeClass('hover');
    jQuery('.region__list li a').removeClass('hover');
    jQuery(`#region-map path[data-id="${tabId}"]`).addClass('hover');
    jQuery(`#${tabId}`).addClass('hover');
  });

  jQuery('.region__list li a').on('mouseover', function () {
    const tabId = jQuery(this).attr('id');

    jQuery('#region-map path').removeClass('hover');
    jQuery('.region__list li a').removeClass('hover');
    jQuery(this).addClass('hover');
    jQuery(`#region-map path[data-id="${tabId}"]`).addClass('hover');
  });

  // Initialize job board filtering and URL management
  jobBoard();
});

// fix layout content shift for gravity forms
jQuery(document).on('gform_post_render', (event, formId, current_page) => {
  const formWrapper = jQuery(`.gform-wrapper[data-form-id="${formId}"]`);
  if (formWrapper.length) {
    formWrapper.addClass('gform_loaded');
  }
});
